import { render, staticRenderFns } from "./census-remark-detail.vue?vue&type=template&id=47c018a7&scoped=true"
import script from "./census-remark-detail.vue?vue&type=script&lang=ts"
export * from "./census-remark-detail.vue?vue&type=script&lang=ts"
import style0 from "./census-remark-detail.vue?vue&type=style&index=0&id=47c018a7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c018a7",
  null
  
)

export default component.exports